import { useQuery, gql, useLazyQuery } from '@apollo/client';

import {
  ValidarAlocacaoQuery,
  ValidarAlocacaoQueryVariables,
} from './__generated__/ValidarAlocacaoQuery';

const VALIDAR_ALOCACAO_QUERY = gql`
  query ValidarAlocacaoQuery($id_professor: Int!, $id_horario: Int!, $dat_alocacao: String!) {
    validar_alocacoes_professores(
      where: { id_professor: $id_professor, id_horario: $id_horario, dat_alocacao: $dat_alocacao }
    ) {
      id_alocacao
      oferta {
        id_oferta
        num_oferta
        curso {
          id_curso
          dsc_nome_curso
        dsc_sigla_curso
        }
      }
      turma {
        id_turma
        num_turma
      }
      disciplina {
        id_disciplina
        dsc_sigla
        num_carga_horaria
      }
      professor {
        id_professor
        dsc_nome_professor
      }
    }
  }
`;

const useValidarAlocacaoQuery = (variables: ValidarAlocacaoQueryVariables) => {
  return useQuery<ValidarAlocacaoQuery, ValidarAlocacaoQueryVariables>(VALIDAR_ALOCACAO_QUERY, {
    variables,
  });
};

const useValidarAlocacaoLazyQuery = () => {
  return useLazyQuery<ValidarAlocacaoQuery, ValidarAlocacaoQueryVariables>(VALIDAR_ALOCACAO_QUERY);
};

export { useValidarAlocacaoQuery, useValidarAlocacaoLazyQuery };
